import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";

export default function SetupPage() {
  const nav = useNavigate();
  const [available, setAvailable] = useState(null);
  const [form, setForm] = useState({ setup_token: "", email: "", password: "", first_name: "", last_name: "" });
  const [err, setErr] = useState(null);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/setup/status").then(r => setAvailable(!r.data.users_exist && r.data.setup_enabled)).catch(() => setAvailable(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await api.post("/setup", form);
      setOk(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Errore durante la configurazione");
    }
    setBusy(false);
  };

  if (available === null) return <div className="ma-auth-wrap"><div className="ma-auth-card">Caricamento…</div></div>;
  if (available === false) return (
    <div className="ma-auth-wrap"><div className="ma-auth-card">
      <div className="ma-brand-lg">MASI<span>ADVICE</span></div>
      <div className="ma-notice">Il wizard non è disponibile: esiste già un amministratore oppure la procedura è disattivata.</div>
      <Link to="/login" className="ma-btn-primary" style={{textAlign:"center", textDecoration:"none"}}>Vai al login</Link>
    </div></div>
  );

  return (
    <div className="ma-auth-wrap">
      <div className="ma-auth-card">
        <div className="ma-brand-lg">MASI<span>ADVICE</span></div>
        <div className="ma-brand-sub">Prima configurazione — Amministratore</div>
        {ok ? (
          <div className="ma-success" data-testid="setup-success">Amministratore creato. Reindirizzamento al login…</div>
        ) : (
          <form onSubmit={submit} className="ma-form">
            <label className="ma-label">Setup token</label>
            <input className="ma-input" value={form.setup_token} onChange={e=>setForm({...form, setup_token: e.target.value})}
                   required data-testid="setup-token" />
            <div className="ma-row">
              <div style={{flex:1}}>
                <label className="ma-label">Nome</label>
                <input className="ma-input" value={form.first_name} onChange={e=>setForm({...form, first_name: e.target.value})}
                       required data-testid="setup-first-name" />
              </div>
              <div style={{flex:1}}>
                <label className="ma-label">Cognome</label>
                <input className="ma-input" value={form.last_name} onChange={e=>setForm({...form, last_name: e.target.value})}
                       required data-testid="setup-last-name" />
              </div>
            </div>
            <label className="ma-label">Email</label>
            <input type="email" className="ma-input" value={form.email} onChange={e=>setForm({...form, email: e.target.value})}
                   required data-testid="setup-email" />
            <label className="ma-label">Password</label>
            <input type="password" className="ma-input" value={form.password} onChange={e=>setForm({...form, password: e.target.value})}
                   required data-testid="setup-password" />
            <div className="ma-hint">Min. 12 caratteri, con maiuscola, minuscola, numero e carattere speciale.</div>
            {err && <div className="ma-error" data-testid="setup-error">{err}</div>}
            <button className="ma-btn-primary" disabled={busy} data-testid="setup-submit">
              {busy ? "Creazione…" : "Crea amministratore"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
